export const siteConfig = {
  businessName: "Pastelaria Casagrande",
  shortName: "Casagrande",
  phoneDisplay: "+351 914 213 268",
  phoneRaw: "351914213268",
  whatsappMessage:
    "Olá! Encontrei a Pastelaria Casagrande através do website e gostaria de fazer uma encomenda.",
  city: "Marinha Grande",
  country: "Portugal",
  address: "Marinha Grande, Portugal",
  openingHours: "Consulte-nos para confirmar o horário",
  directionsUrl: "",
  instagramUrl: "",
  facebookUrl: "",
  domain: import.meta.env.VITE_SITE_URL?.replace(/\/$/, "") ?? "",
  logoSrc: "",
} as const;
